

import React from 'react';
import { Container, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import esm from "./../../assets/EXPEMPTION OF CET FOR EX-AGNIVEER.pdf";
import esm1 from "./../../assets/51 11 2025 4D III onetime cash award to Aganiveer.pdf"
import esm2 from "./../../assets/53 11 2025 4D III Ex Gratia grant to Agniveer.pdf"
import esm3 from "./../../assets/reservation.pdf"
import esm4 from "./../../assets/Age relaxation.pdf"

const policies = [
  { title: 'Exemption from CET exam for recruitment in group C and D posts.', file: esm },
  { title: 'One time cash award for gallantry/ distinguished/ Devotion to duty award winner.', file: esm1 },
  { title: 'Ex-gratia grant of Rs. 1.00 crore to the family member/NOKs of martyr.', file: esm2 },
  { title: 'Reservation in direct recruitment in various departments of Haryana HOME/ Environment, Forest & wildlife/ Prison/ Mines and Geology departments.', file: esm3 },
  { title: 'Age relaxation in direct recruitment to Ex-agniveers for group B & C posts.', file: esm4 }
];

const Policies = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
            Agniveer Policies
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
              Available Policies
            </h4>
          </div>
          <CardBody className="p-4">
            <ListGroup flush>
              {policies.map((policy, index) => (
                <ListGroupItem 
                  key={index}
                  className="d-flex align-items-center justify-content-between"
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #e9ecef',
                    padding: '15px 20px'
                  }}
                >
                  <div className="d-flex align-items-center me-3">
                    <div style={{
                      background: 'rgba(30,60,114,0.1)',
                      color: '#1e3c72',
                      padding: '10px 15px',
                      borderRadius: '8px',
                      marginRight: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: '30px',
                      fontWeight: '600'
                    }}>
                      {index + 1}
                    </div>
                    <span style={{ color: '#495057', fontSize: '1.05rem' }}>
                      {policy.title}
                    </span>
                  </div>
                  <a
                    href={policy.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#1e3c72',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: '600',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 16px',
                      borderRadius: '20px',
                      border: '2px solid #1e3c72',
                      transition: 'all 0.3s',
                      minWidth: '120px',
                      justifyContent: 'center'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = '#1e3c72';
                      e.currentTarget.style.color = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#1e3c72';
                    }}
                  >
                    View PDF
                    <FontAwesomeIcon icon={faFilePdf} />
                  </a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Policies;
